export type ScanBannerTone = 'success' | 'warning' | 'error';

type ManifestAcceptanceScanBannerProps = {
  tone: ScanBannerTone;
  bagNumber: string;
  message: string;
};

const toneStyles: Record<ScanBannerTone, { backgroundColor: string; borderColor: string; titleColor: string }> = {
  success: {
    backgroundColor: '#e8f7ee',
    borderColor: '#31a35a',
    titleColor: '#1d6b3b',
  },
  // мешок принят, но с предупреждением (незаявленный) — оператор должен это заметить, но работа не останавливается
  warning: {
    backgroundColor: '#fff4e5',
    borderColor: '#f0a202',
    titleColor: '#8a5a00',
  },
  error: {
    backgroundColor: '#fdecec',
    borderColor: '#d14343',
    titleColor: '#9f1f1f',
  },
};

export default function ManifestAcceptanceScanBanner({ tone, bagNumber, message }: ManifestAcceptanceScanBannerProps) {
  const style = toneStyles[tone];

  return (
    <div
      style={{
        width: '100%',
        border: `1px solid ${style.borderColor}`,
        backgroundColor: style.backgroundColor,
        borderRadius: 12,
        padding: 12,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          color: style.titleColor,
          fontWeight: 700,
          fontSize: 16,
          marginBottom: 4,
          wordBreak: 'break-word',
        }}
      >
        {bagNumber}
      </div>
      <div style={{ color: '#222', fontSize: 14, wordBreak: 'break-word' }}>{message}</div>
    </div>
  );
}
